'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  min-height: ', ';\n  padding: 20px 15px 15px;\n\n  svg {\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  @media (min-width: ', ') {\n    min-height: 0;\n    padding: 0;\n  }\n'], ['\n  min-height: ', ';\n  padding: 20px 15px 15px;\n\n  svg {\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  @media (min-width: ', ') {\n    min-height: 0;\n    padding: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: ', ';\n  font-weight: 700;\n\n  &:empty {\n    display: none;\n  }\n\n  @media (min-width: ', ') {\n    font-size: ', ';\n    line-height: 3rem;\n  }\n'], ['\n  color: ', ';\n  font-size: ', ';\n  font-weight: 700;\n\n  &:empty {\n    display: none;\n  }\n\n  @media (min-width: ', ') {\n    font-size: ', ';\n    line-height: 3rem;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _YellowLineSVG = require('../../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HEIGHT_MAP = {
  1: '55px',
  2: '80px',
  3: '80px',
  4: '80px',
  5: '80px',
  6: '80px',
  7: '200px'
};

var TitleContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return HEIGHT_MAP[props.height] || 'auto';
}, _config.breakpoints.m);

var HeadingContainer = _styledComponents2.default.h2(_templateObject2, _config.colors.white, (0, _rem2.default)('24px', _config.typography.baseFontSize), _config.breakpoints.m, (0, _rem2.default)('38px', _config.typography.baseFontSize));

var Title = function Title(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      height = _ref.height;
  return _react2.default.createElement(
    TitleContainer,
    {
      $decorator: !!title,
      height: height
    },
    title && height > 1 && _react2.default.createElement(_YellowLineSVG2.default, null),
    title && height > 1 && _react2.default.createElement(
      HeadingContainer,
      null,
      title
    )
  );
};

Title.displayName = 'Title';

Title.propTypes = {
  /** the title. */
  title: _propTypes2.default.string,
  /** the height level (1-6). */
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
};

exports.default = Title;
Title.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Title',
  'props': {
    'title': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'the title.'
    },
    'height': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }]
      },
      'required': true,
      'description': 'the height level (1-6).'
    }
  }
};